export interface CommandResultData<T = Record<string, unknown>> {
  result: "ok"
  data: T
}

export interface CommandErrorData<T = Record<string, unknown>> {
  result: "error"
  error: string
  data?: T
  traceback?: string
}

export type RawResponse<T = Record<string, unknown>> =
  | CommandResultData<T>
  | CommandErrorData<T>

export class CommandResult<T = Record<string, unknown>> {
  readonly ok: boolean
  readonly data: T | undefined
  readonly error: string | undefined
  readonly traceback: string | undefined

  private constructor(raw: RawResponse<T>) {
    this.ok = raw.result === "ok"
    if (raw.result === "ok") {
      this.data = raw.data
      this.error = undefined
      this.traceback = undefined
    } else {
      this.data = raw.data
      this.error = raw.error
      this.traceback = raw.traceback
    }
  }

  static fromResponse<T = Record<string, unknown>>(raw: RawResponse<T>): CommandResult<T> {
    return new CommandResult(raw)
  }

  /** Throw if the command failed; otherwise return the data. */
  unwrap(): T {
    if (!this.ok) {
      throw new Error(this.error ?? "Command failed")
    }
    return this.data as T
  }
}
